(function () {
  'use strict';

  /* ========================================================================
     TMC Quiz — ADDEDFREE offer + persistent results bar
     Loaded on every page. Three jobs, run in this order:
       1. Prefill the checkout email field from the quiz
       2. Make sure ADDEDFREE has landed once the customer reaches /cart
       3. Show the persistent results bar (not on the quiz page or /cart)
     Reads state from localStorage; flags persist in sessionStorage.
     ======================================================================== */

  var STORAGE_KEY = 'tmc_quiz_state_v2';
  var DISMISS_KEY = 'tmc_quiz_bar_dismissed';
  var RECONCILE_KEY = 'tmc_quiz_offer_reconciled';

  /* Mirrors the offer block in custom-tmc-quiz.js — keep both in sync. */
  var DISCOUNT_CODE = 'ADDEDFREE';
  var PRICE_ONETIME = 69.0;
  var PRICE_SUBSCRIPTION = 58.65;
  var FREE_ITEM_MIN_COUNT = 2;

  var PRODUCTS = {
    foundation: { name: 'Foundation', variantId: 45071549694256, sellingPlanId: 688791617840 },
    mood: { name: 'Mood', variantId: 45071560933680, sellingPlanId: 688791945520 },
    sleep: { name: 'Sleep', variantId: 45071562834224, sellingPlanId: 688791683376 },
    libido: { name: 'Libido', variantId: 45071556378928, sellingPlanId: 688791978288 },
    focus: { name: 'Focus', variantId: 45071549006128, sellingPlanId: 688791650608 },
    energy: { name: 'Energy', variantId: 45071547990320, sellingPlanId: 688791912752 },
  };

  // Read state once — used by the prefill, the reconcile and the bar
  var state;
  try {
    var raw = localStorage.getItem(STORAGE_KEY);
    if (raw) state = JSON.parse(raw);
  } catch (e) {}

  var recs =
    state && state.currentStep === 'results' && state.results && state.results.recs && state.results.recs.length
      ? state.results.recs
      : null;

  /* Saving on the first order against paying full one-time price for everything. */
  function firstOrderSaving(recCount, subscribe) {
    var paid = recCount >= FREE_ITEM_MIN_COUNT ? recCount - 1 : recCount;
    return recCount * PRICE_ONETIME - paid * (subscribe ? PRICE_SUBSCRIPTION : PRICE_ONETIME);
  }

  /* Index of the line ADDEDFREE covers — always the lowest-priority pick.
     -1 when the plan is too small to qualify. */
  function freeIndex(list) {
    return list && list.length >= FREE_ITEM_MIN_COUNT ? list.length - 1 : -1;
  }

  /* The product ADDEDFREE covers. Null when the plan is too small to qualify. */
  function freeProduct(list) {
    var i = freeIndex(list);
    return i < 0 ? null : PRODUCTS[list[i].product];
  }

  /* Line items for /cart/add.js. The free line stays one-time even in the
     subscribe flow: Skio does not honour ADDEDFREE on subscription lines, so
     the discount can only zero out a non-subscription line. */
  function buildCartItems(list, subscribe) {
    var free = freeIndex(list);
    /* Free line first — see the matching comment in custom-tmc-quiz.js. */
    var ordered = free < 0 ? list : [list[free]].concat(list.slice(0, free));
    var freePos = free < 0 ? -1 : 0;
    return ordered.map(function (rec, i) {
      var p = PRODUCTS[rec.product];
      var item = { id: p.variantId, quantity: 1 };
      if (subscribe && i !== freePos) item.selling_plan = p.sellingPlanId;
      return item;
    });
  }

  /* Applies ADDEDFREE via Shopify's own discount route, which sets the
     discount_code cookie. Fire-and-forget — never block the cart drawer. */
  function applyOfferCode() {
    return fetch('/discount/' + DISCOUNT_CODE + '?redirect=/cart.js', { credentials: 'same-origin' }).catch(
      function () {},
    );
  }

  /* ---- 1. Checkout email prefill ---- */
  if (state && state.email) {
    var emailField = document.getElementById('email');
    if (emailField && !emailField.value) {
      emailField.value = state.email;
    }
  }

  /* ---- 2. Offer reconcile on /cart ---- */

  function hasOfferCode(cart) {
    if (cart.total_discount > 0) return true;
    var codes = cart.discount_codes || [];
    for (var i = 0; i < codes.length; i++) {
      if (codes[i].code && codes[i].code.toUpperCase() === DISCOUNT_CODE) return true;
    }
    return false;
  }

  /* Safety net for when the discount route was missed — a blocked fetch, or an
     emailed link whose hop was dropped. Only runs for customers we actually
     sent the offer to: either quiz state is on this device, or the URL carries
     the ?offer marker from the emailed link (which may open anywhere).
     The sessionStorage flag is set BEFORE navigating so an expired or rejected
     code cannot cause a reload loop. */
  function reconcileCartOffer() {
    var invited =
      (recs && recs.length >= FREE_ITEM_MIN_COUNT) || window.location.search.indexOf('offer=' + DISCOUNT_CODE) !== -1;
    if (!invited) return;

    try {
      if (sessionStorage.getItem(RECONCILE_KEY)) return;
    } catch (e) {}

    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        if (cart.item_count < FREE_ITEM_MIN_COUNT || hasOfferCode(cart)) return;
        try {
          sessionStorage.setItem(RECONCILE_KEY, '1');
        } catch (e) {}
        window.location.href = '/discount/' + DISCOUNT_CODE + '?redirect=/cart';
      })
      .catch(function () {});
  }

  if (/\/cart\/?$/.test(window.location.pathname)) {
    reconcileCartOffer();
    return;
  }

  /* ---- 3. Persistent results bar ---- */
  // Don't show on the quiz page itself
  if (document.getElementById('tmc-quiz-root')) return;

  try {
    if (sessionStorage.getItem(DISMISS_KEY)) return;
  } catch (e) {}

  if (!recs) return;

  var free = freeProduct(recs);
  var subscribeLabel = free
    ? 'Subscribe — 1 product free'
    : 'Subscribe & Save $' + firstOrderSaving(recs.length, true).toFixed(2);

  function dismiss() {
    try {
      sessionStorage.setItem(DISMISS_KEY, '1');
    } catch (e) {}
    var bar = document.getElementById('tmc-quiz-bar');
    if (!bar) return;
    bar.classList.remove('is-visible');
    setTimeout(function () {
      if (bar.parentNode) bar.parentNode.removeChild(bar);
    }, 320);
  }

  function addToCart(subscribe) {
    var btnId = subscribe ? 'tmc-bar-subscribe' : 'tmc-bar-onetime';
    var btn = document.getElementById(btnId);
    if (!btn || btn.classList.contains('is-loading')) return;
    btn.classList.add('is-loading');
    btn.disabled = true;

    var cartItems = buildCartItems(recs, subscribe);

    fetch('/cart/clear.js', { method: 'POST' })
      .then(function () {
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
          body: JSON.stringify({ items: cartItems }),
        });
      })
      .then(function (r) {
        return r.json();
      })
      .then(function (response) {
        /* Apply ADDEDFREE after the add so the drawer refresh below reflects it. */
        if (cartItems.length < FREE_ITEM_MIN_COUNT) return response;
        return applyOfferCode().then(function () {
          return response;
        });
      })
      .then(function (response) {
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'quiz-bar', cartData: response });
        }
        var cartDrawer = document.querySelector('cart-drawer');
        if (cartDrawer) {
          fetch('/?sections=cart-drawer')
            .then(function (r) {
              return r.json();
            })
            .then(function (sections) {
              var drawerEl = document.getElementById('CartDrawer');
              if (drawerEl && sections['cart-drawer']) {
                var parsed = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
                var newContent = parsed.querySelector('#CartDrawer');
                if (newContent) drawerEl.innerHTML = newContent.innerHTML;
              }
              var overlay = cartDrawer.querySelector('#CartDrawer-Overlay');
              if (overlay) overlay.addEventListener('click', cartDrawer.close.bind(cartDrawer));
              cartDrawer.open();
            });
        }
        dismiss();
      })
      .catch(function (err) {
        console.error('Quiz bar add to cart error:', err);
      })
      .finally(function () {
        if (btn) {
          btn.classList.remove('is-loading');
          btn.disabled = false;
        }
      });
  }

  var productLinks = recs
    .map(function (rec) {
      var p = PRODUCTS[rec.product];
      if (!p) return '';
      return '<a class="tmc-quiz-bar__product-link" href="/products/' + rec.product + '">' + p.name + '</a>';
    })
    .filter(Boolean)
    .join('<span class="tmc-quiz-bar__dot"> · </span>');

  var bar = document.createElement('div');
  bar.id = 'tmc-quiz-bar';
  bar.className = 'tmc-quiz-bar';
  bar.setAttribute('role', 'region');
  bar.setAttribute('aria-label', 'Your personalised supplement plan');

  bar.innerHTML =
    '<div class="tmc-quiz-bar__left">' +
    '<span class="tmc-quiz-bar__label">Your plan</span>' +
    '<span class="tmc-quiz-bar__products">' +
    productLinks +
    '</span>' +
    '</div>' +
    '<div class="tmc-quiz-bar__actions">' +
    '<button id="tmc-bar-subscribe" class="tmc-quiz-bar__btn tmc-quiz-bar__btn--subscribe">' +
    '<span class="tmc-quiz-bar__btn-text">' +
    subscribeLabel +
    '</span>' +
    '<span class="tmc-quiz-bar__spinner"></span>' +
    '</button>' +
    '<button id="tmc-bar-onetime" class="tmc-quiz-bar__btn tmc-quiz-bar__btn--onetime">' +
    '<span class="tmc-quiz-bar__btn-text">One-time</span>' +
    '<span class="tmc-quiz-bar__spinner"></span>' +
    '</button>' +
    '</div>' +
    '<button class="tmc-quiz-bar__close" aria-label="Dismiss your plan bar">&times;</button>';

  document.body.appendChild(bar);

  requestAnimationFrame(function () {
    requestAnimationFrame(function () {
      bar.classList.add('is-visible');
    });
  });

  document.getElementById('tmc-bar-subscribe').addEventListener('click', function () {
    addToCart(true);
  });
  document.getElementById('tmc-bar-onetime').addEventListener('click', function () {
    addToCart(false);
  });
  bar.querySelector('.tmc-quiz-bar__close').addEventListener('click', dismiss);
})();
